<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row @keyup.enter="load" class="align-items-center">
          <b-col lg="2" sm="12" class="text-left">
            <lg-form-const-select label="Situação:" v-model="form.situacao" :options="form.optionsFilterSituacao"
              @change="load" />
          </b-col>
          <b-col lg="6" sm="12" class="text-left">
            <lg-form-input v-model="form.descricao" label="Descrição:" />
          </b-col>
          <b-col lg="1" sm="1" class="ml-4 d-flex justify-content-end align-items-center">
            <b-button id="localizarTipoMedida" class="mx-2 my-2 ml-6" size="sm" style="height: 20px" pill
              variant="primary" @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
              <b-tooltip target="localizarTipoMedida" title="Localizar"></b-tooltip>

            </b-button>
            <b-button id="adicionarTipoMedida" class="mx-2 ml-4 my-2" size="sm" style="height: 20px" @click="cadastrarTipoMedidaModal" pill
              variant="primary" v-if="temPrivilegioCriacao()" >
              <div class="btn-size-alinhamento">
                <b-icon scale="1" icon="plus" />
              </div>
              <b-tooltip target="adicionarTipoMedida" title="Adicionar novo..."></b-tooltip>

            </b-button>
          </b-col>
        </b-form-row>
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" @row-dblclicked="selectTipoMedida" show-empty  >
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>

          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(situacao)="row">
            <div :id="row.index + 'ativar'">
              <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="row.item.situacao" switch :value="1" :unchecked-value="0"
                @change="alteraSituacao(row.item)" />
              <b-tooltip :target="row.index + 'ativar'" title="Ativar/Desativar..."></b-tooltip>
            </div>
          </template>

          <template v-slot:cell(editarTipoMedida)="row">
            <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
              @click="editarTipoMedida(row.item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
            </b-button>
          </template>
        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total" ></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
    <TipoMedidaForm v-if="cadastrarTipoMedida" @close="cancelar" :prefix="title" :id="currentTipoMedidaId"
      @update:showModal="val => (showModal = val)" />
  </b-card>
</template>

<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import TipoMedidaForm from "./TipoMedidaForm.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import TipoMedidaService from "@/core/api/TipoMedidaService"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    TipoMedidaForm,
  },

  props: {
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Tipo de Medida > ",
    },
  },
  data() {
    return {
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      cadastrarTipoMedida: false,
      currentTipoMedidaId: null,
      showModal: false,
      filtro: {
        descricao: "",
        situacao: "",
      },
      form: {
        descricao: "",
        situacao: 1,
        optionsFilterSituacao: [
          { key: "filterSituacao", text: "Todos", value: null },
          { key: "filterSituacao", text: "Ativo", value: 1 },
          { key: "filterSituacao", text: "Inativo", value: 0 },
        ],
      },
    }
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$TipoMedidaService = new TipoMedidaService()
  },
  mounted() {
    this.load()
  },
  watch: {
    page() {
      this.load()
    },
  },
  computed: {
    tableFields() {
      return [
        { key: "descricao", label: "Descrição" },
        { key: "editarTipoMedida", label: "", tdClass: "w-8" },
        { key: "situacao", label: "", tdClass: "w-4" },
      ]
    },
  },
  methods: {
    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_EDITAR);

    },


    temPrivilegioCriacao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_INCLUIR);

    },

    selectTipoMedida(item){
      this.$emit("select", item);
    },
    async load() {
      this.busy = true
      await this.$TipoMedidaService
        .findAll({
          size: this.perPage,
          page: this.page,
          descricao: this.form.descricao,
          situacao: this.form.situacao,
        })
        .then(response => {
          this.records = response.data.content
          this.total = response.data.totalElements
          this.totalPage = response.data.totalPages
        })
        .finally(() => {
          this.busy = false
        })
    },

    cadastrarTipoMedidaModal() {
      this.cadastrarTipoMedida = true
    },

    fecharCadastroTipoModal() {
      this.cadastrarTipoMedida = false
    },

    cancelar() {
      this.currentTipoMedidaId = null
      this.cadastrarTipoMedida = false
      this.showModal = false
      this.load()
    },

    async alteraSituacao(item) {
      let response
      if (item.situacao == 1) {
        response = await this.$confirm(
          `Deseja ativar o Tipo de Medida?`,
          item.descricao.toUpperCase()
        )
      }

      if (item.situacao == 0) {
        response = await this.$confirm(
          `Deseja desativar o Tipo de Medida?`,
          item.descricao.toUpperCase()
        )
      }

      if (response === true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao == 1 ? 0 : 1
      }
    },

    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$TipoMedidaService.alteraSituacao(item)
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },

    editarTipoMedida(item) {
      this.currentTipoMedidaId = item.id
      this.cadastrarTipoMedida = true
    },
  },
}
</script>
